/** ----------------------------------------
    Service
---------------------------------------- */

import { ProjectService } from '@store/service/ProjectService';
import { FileService } from '@store/service/FileService';
import { merge, omitBy, isNil } from 'lodash';

/** ----------------------------------------
    Actions
---------------------------------------- */

const actions = {
    async fetch({ commit }: any, payload: any) {
        const projectService = new ProjectService(this);
        return projectService.getProject(payload)
            .then(response => {
                if (response instanceof Error)
                    return response;

                const data = response.data;
                return data;
            });
    },

    async fetchCurrent({ commit }: any, payload: any) {
        const projectService = new ProjectService(this);
        return projectService.getProject(payload)
            .then(response => {
                return this.dispatch('project/setCurrentProject', response)
            });
    },

    async create({ commit }: any, payload: any) {
        const projectService = new ProjectService(this);
        return projectService.postProject(payload)
            .then(response => {
                return this.dispatch('project/setCurrentProject', response)
            });
    },

    async setCurrentProject({ commit }: any, payload: any) {
        if (payload instanceof Error)
            return payload;

        const project = payload.data;

        if (!project) return;

        return Promise.all([
            this.dispatch('organisation/fetch', project.organisation_id),
            this.dispatch('organisation/fetchFiles', project.organisation_id)
        ]).then(function(response) {
            if (response[0] instanceof Error || response[1] instanceof Error)
                return response;

            const organisation = response[0];
            const files = response[1];

            project.organisation = organisation;
            project.organisation_files = files;

            commit('setCurrent', project);

            return project;
        });
    },

    async update({ commit }: any, payload: any) {
        const projectService = new ProjectService(this);
        return projectService.putProject(payload.id, payload)
            .then(response => {
                if (response instanceof Error)
                    return response;

                return true;
            });
    },

    async updateCurrent({ commit, state }: any, payload: any) {
        commit('setCurrent', payload);

        const id = payload.id;
        let data = merge({}, payload);

        // Update organisation and remove from data
        if (payload.organisation) {
            this.dispatch('organisation/update', payload.organisation);
        }

        // Merge current project with saving data
        // data = merge(state.current, data);

        // Remove data that shouldn't be updated
        delete data.id;
        delete data.organisation;

        // Remove props with value null
        data = omitBy(data, isNil)

        // Put project
        const projectService = new ProjectService(this);
        return projectService.putProject(id, data)
            .then(response => {
                if (response instanceof Error)
                    return response;

                return response.data;
            });
    },

    async uploadFile({ commit }: any, payload: any) {
        const fileService = new FileService(this);
        return fileService.postFile(payload)
            .then(response => {
                if (response instanceof Error)
                    return response;

                return response;
            });
    },

    async submit({ commit }: any, payload: any) {
        const projectService = new ProjectService(this);
        return projectService.submitProject(payload.id, payload)
            .then(response => {
                if (response instanceof Error)
                    return response;

                return response.data;
            });
    },

    async fetchFiles({ commit }: any, payload: any) {
        const fileService = new FileService(this);
        return fileService.getFiles(payload, 'project');
    },
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default actions;